import css from './page-sub-header.module.scss';

export default function PageSubHeader(props) {
  const { title = "" } = props;

  return <h3 className={css.pageSubHeader}>{title}</h3>;
}
